import { ref } from "vue";
import { Store } from "../types/store";
export type UserStore = {
  store: string;
  user: string;
  merchant: string;
  data: Store;
};
export const initialize = () => {
  const stores = ref<UserStore[]>([]);
  const currentStore = ref<UserStore>();
  const setStores = (items: UserStore[]) => {
    stores.value = items;
  };
  const setCurrentStore = (store: UserStore) => {
    currentStore.value = store;
    localStorage.setItem("currentStore", JSON.stringify(store));
  };
  const getCurrentStore = () => {
    const store = localStorage.getItem("currentStore");
    if (store) {
      currentStore.value = JSON.parse(store) as UserStore;
    }
  };
  // Reset all store state. Must be called on logout, otherwise this
  // module-level singleton keeps the previous user's store in memory and the
  // dashboard (which only selects a store when currentStore is empty) shows the
  // old store's name/data to the newly logged-in user.
  const clear = () => {
    currentStore.value = undefined;
    stores.value = [];
    localStorage.removeItem("currentStore");
  };

  return () => ({
    stores,
    currentStore,
    getCurrentStore,
    setStores,
    setCurrentStore,
    clear,
  });
};

export const useStores = initialize();
